import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { MdOpenInNew } from 'react-icons/md';
import PersonHoverCard from 'components/common/PersonHoverCard';

/**
 * The employee's manager: hover for their identity card, click through to their
 * own record. The card itself lives in PersonHoverCard, shared with the travel
 * booking traveller list so both read identically.
 */
const ManagerLink = ({ manager }) => {
  if (!manager?.id) return <span className="tw-text-slate-300 tw-text-sm">N/A</span>;

  return (
    <PersonHoverCard person={manager}>
      <Link
        to={`/organization/employees/${manager.id}`}
        target="_blank"
        rel="noopener noreferrer"
        title={`Open ${manager.full_name || manager.name}'s employee record in a new tab`}
        className="tw-text-sm tw-font-medium tw-text-primary-600 hover:tw-underline tw-inline-flex tw-items-center tw-gap-1"
      >
        {manager.name}
        <MdOpenInNew size={11} className="tw-opacity-60" />
      </Link>
    </PersonHoverCard>
  );
};

ManagerLink.propTypes = {
  manager: PropTypes.shape({
    id:        PropTypes.number,
    name:      PropTypes.string,
    full_name: PropTypes.string,
    email:     PropTypes.string,
    title:     PropTypes.string,
    site:      PropTypes.string,
    active:    PropTypes.bool,
  }),
};

export default ManagerLink;
